import { computed, inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectOrganization, selectDistanceUnit } from './user-profile.selectors';

@Injectable({ providedIn: 'root' })
export class UserProfileFacade {
  private store = inject(Store);

  readonly distanceUnit = this.store.selectSignal(selectDistanceUnit);
  readonly userOrg = this.store.selectSignal(selectOrganization);
  readonly sideNavEnabled = computed(() => this.userOrg()?.configurationSettings?.enableNewNavigation);
}
